import { IIcon } from './bueno-icon.types';

export const ICONS_LIST: IIcon[] = [
  {
    name: 'bueno-search',
    path: '../assets/new-des-icons/search-default-big.svg',
  },
  {
    name: 'bueno-initial',
    path: '../assets/new-des-icons/bueno-initials.svg',
  },
  {
    name: 'bueno-transaction',
    path: '../assets/new-des-icons/transfers.svg',
  },
  {
    name: 'bueno-debit',
    path: '../assets/new-des-icons/debit.svg',
  },
  {
    name: 'bueno-debit-outcome',
    path: '../assets/new-des-icons/debit-outcome.svg',
  },
  {
    name: 'bueno-building',
    path: '../assets/new-des-icons/building.svg',
  },
  {
    name: 'bueno-credit-card',
    path: '../assets/new-des-icons/credit-card.svg',
  },
  {
    name: 'bueno-credit-card-income',
    path: '../assets/new-des-icons/credit-card-income.svg',
  },
  {
    name: 'bueno-credit-card-outcome',
    path: '../assets/new-des-icons/credit-card-outcome.svg',
  },
  {
    name: 'bueno-bell',
    path: '../assets/new-des-icons/bell.svg',
  },
  {
    name: 'bueno-chat',
    path: '../assets/new-des-icons/chat.svg',
  },
  {
    name: 'bueno-user',
    path: '../assets/new-des-icons/user.svg',
  },
  {
    name: 'bueno-user-2',
    path: '../assets/new-des-icons/user_2.svg',
  },
  {
    name: 'bueno-earth',
    path: '../assets/new-des-icons/earth.svg',
  },
  {
    name: 'bueno-text',
    path: '../assets/new-des-icons/Bueno-text.svg',
  },
  {
    name: 'bueno-chip',
    path: '../assets/new-des-icons/chip.svg',
  },
  {
    name: 'bueno-copy',
    path: '../assets/new-des-icons/copy.svg',
  },
  {
    name: 'bueno-send-money',
    path: '../assets/new-des-icons/send-money.svg',
  },
  {
    name: 'bueno-transaction-history',
    path: '../assets/new-des-icons/payment-history.svg',
  },
  {
    name: 'bueno-top-up',
    path: '../assets/new-des-icons/top-up.svg',
  },
  {
    name: 'bueno-add',
    path: '../assets/new-des-icons/add.svg',
  },
  {
    name: 'bueno-location',
    path: '../assets/new-des-icons/location.svg',
  },
  {
    name: 'bueno-coin',
    path: '../assets/new-des-icons/coin.svg',
  },
  {
    name: 'bueno-status-success',
    path: '../assets/new-des-icons/status-success.svg',
  },
  {
    name: 'bueno-status-declined',
    path: '../assets/new-des-icons/status-declined.svg',
  },
  {
    name: 'bueno-status-warning',
    path: '../assets/new-des-icons/status-warning.svg',
  },
  {
    name: 'bueno-status-cancelled',
    path: '../assets/new-des-icons/status-cancelled.svg',
  },
  {
    name: 'bueno-status-premium',
    path: '../assets/new-des-icons/premium.svg',
  },
  {
    name: 'bueno-premium-club',
    path: '../assets/new-des-icons/bueno-club.svg',
  },
  {
    name: 'bueno-transfer-income',
    path: '../assets/new-des-icons/transfer-income.svg',
  },
  {
    name: 'bueno-transfer-outcome',
    path: '../assets/new-des-icons/transfer-outcome.svg',
  },
  {
    name: 'bueno-transfer-cancelled',
    path: '../assets/new-des-icons/transfer-cancelled.svg',
  },
  {
    name: 'bueno-load',
    path: '../assets/new-des-icons/load.svg',
  },
  {
    name: 'bueno-arrow-down',
    path: '../assets/new-des-icons/arrow-down.svg',
  },
  {
    name: 'bueno-arrow-up',
    path: '../assets/new-des-icons/arrow-up.svg',
  },
  {
    name: 'bueno-referral',
    path: '../assets/new-des-icons/referral.svg',
  },
  {
    name: 'bueno-contacts',
    path: '../assets/new-des-icons/contacts.svg',
  },
  {
    name: 'bueno-transfer-cash',
    path: '../assets/new-des-icons/transfer-cash.svg',
  },
  {
    name: 'bueno-delete',
    path: '../assets/new-des-icons/delete.svg',
  },
  {
    name: 'bueno-handshake',
    path: '../assets/new-des-icons/handshake.svg',
  },
  {
    name: 'bueno-sort',
    path: '../assets/new-des-icons/sort.svg',
  },
  {
    name: 'bueno-statement',
    path: '../assets/new-des-icons/statement.svg',
  },
  {
    name: 'bueno-standing-order',
    path: '../assets/new-des-icons/standing-order.svg',
  },
  {
    name: 'bueno-account',
    path: '../assets/new-des-icons/account.svg',
  },
  {
    name: 'bueno-initials-rounded',
    path: '../assets/new-des-icons/initials-rounded.svg',
  },
  {
    name: 'bueno-double-bed',
    path: '../assets/new-des-icons/double-bed.svg',
  },
  {
    name: 'bueno-square-resize',
    path: '../assets/new-des-icons/square-resize.svg',
  },
  {
    name: 'bueno-shower',
    path: '../assets/new-des-icons/shower.svg',
  },
  {
    name: 'bueno-calendar',
    path: '../assets/new-des-icons/calendar.svg',
  },
  {
    name: 'bueno-beach',
    path: '../assets/new-des-icons/beach.svg',
  },
  {
    name: 'bueno-house-type',
    path: '../assets/new-des-icons/house-type.svg',
  },
  {
    name: 'bueno-parking',
    path: '../assets/new-des-icons/parking.svg',
  },
  {
    name: 'bueno-pool',
    path: '../assets/new-des-icons/pool.svg',
  },
  {
    name: 'bueno-solar',
    path: '../assets/new-des-icons/solar.svg',
  },
  {
    name: 'bueno-terrace',
    path: '../assets/new-des-icons/terrace.svg',
  },
  {
    name: 'bueno-comment',
    path: '../assets/new-des-icons/comment.svg',
  },
  {
    name: 'bueno-currency',
    path: '../assets/new-des-icons/currency.svg',
  },
  {
    name: 'bueno-envelope',
    path: '../assets/new-des-icons/envelope.svg',
  },
  {
    name: 'bueno-filter',
    path: '../assets/new-des-icons/filter.svg',
  },
  {
    name: 'bueno-note',
    path: '../assets/new-des-icons/note.svg',
  },
  {
    name: 'bueno-phone',
    path: '../assets/new-des-icons/phone.svg',
  },
  {
    name: 'bueno-time',
    path: '../assets/new-des-icons/time.svg',
  },
  {
    name: 'bueno-whatsapp',
    path: '../assets/new-des-icons/whatsapp.svg',
  },
];
